// src/components/ScrollToggleButton.jsx
import { useState } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import "../styles/banner.css";

const ScrollToggleButton = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    const formSection = document.getElementById("registration-form");

    if (!isScrolled && formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
      setIsScrolled(true);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsScrolled(false);
    }
  };

  return (
    <div
      className="scroll-down-icon"
      onClick={handleScroll}
    >
      {isScrolled ? (
        <FaArrowUp
          size={30}
          color="white"
        />
      ) : (
        <FaArrowDown
          size={30}
          color="white"
        />
      )}
    </div>
  );
};

export default ScrollToggleButton;
